"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Session_module_1 = require("./modules/Session.module");
const loadProductWizardModule = () => ({
    hasRouter: false,
    modules: [(0, Session_module_1.default)()],
});
exports.default = loadProductWizardModule;
